import React, { useEffect, useState } from "react";
import Profil from "./Profil";
import Hakkimda from "./Hakkimda";
import Beceriler from "../junior-senior/Beceriler";
import Dilbilgisi from "../junior-senior/Dilbilgisi";
import Projects from "../junior-senior/Projects";
import Education from "../junior-senior/Education";
import GeriBildirimler from "./GeriBildirimler";
import { Modal } from "./Modal";
import { useDispatch, useSelector } from "react-redux";
import { getUserById } from "../../redux/actions/userActions";
import HesabimLoader from "../../components/loader/HesabimLoader";

const Hesabim = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const dispatch = useDispatch();
  const requestedUserId = useSelector((state) => state.auth.userId);
  const { loading, error, user } = useSelector((state) => state.user);

  useEffect(() => {
    if (requestedUserId) {
      dispatch(getUserById(requestedUserId));
    }
  }, [dispatch, requestedUserId]);

  // Hash'e göre scroll işlemi
  useEffect(() => {
    const hash = window.location.hash;
    if (hash === "#anketOylamasi" || hash === "#geriBildirimler") {
      setTimeout(() => {
        const elementId =
          hash === "#anketOylamasi" ? "anketOylamasi" : "geriBildirimler";
        const element = document.getElementById(elementId);
        if (element) {
          const headerOffset = hash === "#anketOylamasi" ? 100 : 0; // anketOylamasi için offset, geriBildirimler için 0
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      }, 500);
    }
  }, [user]);

  if (loading) return <HesabimLoader />;
  if (error)
    return (
      <p className="text-red-500 text-center">
        Hata: {error.message || JSON.stringify(error)}
      </p>
    );
  if (!user || Object.keys(user).length === 0)
    return <p className="text-center">Kullanıcı bulunamadı.</p>;
  return (
    <div className="containerMain">
      <h1 className="text-2xl font-bold leading-10 text-left mb-4">Hesabım</h1>
      <div className="flex flex-col justify-center lg:grid gap-8 lg:grid-cols-3">
        <div className="left-area max-w-[500px]">
          <Profil 
            setIsOpen={setIsOpen} 
            setModalType={setModalType} 
            user={user.data}
            userId={requestedUserId}
          />
        </div>
        <div className="right-area col-span-2">
          <Hakkimda 
            setIsOpen={setIsOpen} 
            setModalType={setModalType} 
            user={user.data}
          />
          <div className="grid grid-cols-2">
            <Beceriler
              page="hesabim"
              setIsOpen={setIsOpen}
              setModalType={setModalType}
              hesabimUserData={user.data}
              hesabimUserId={requestedUserId}
            />
            <Dilbilgisi
              page="hesabim"
              setIsOpen={setIsOpen}
              setModalType={setModalType}
              hesabimUserData={user.data}
            />
          </div>
          <Projects page="hesabim" hesabimUserData={user.data}
              hesabimUserId={requestedUserId}/>
          <Education
            page="hesabim"
            setIsOpen={setIsOpen}
            setModalType={setModalType}
            hesabimUserData={user.data}
          />
          {user?.data?.type === "JUNIOR" && (
            <>
              <div id="anketOylamasi">
                <GeriBildirimler user={user} />
              </div>
            </>
          )}
        </div>
      </div>
      {isOpen && <Modal type={modalType} onClose={() => setIsOpen(false)} />}
    </div>
  );
};

export default Hesabim;
